export const gaode_address_data={
    "status": "1",
    "info": "OK",
    "infocode": "10000",
    "count": "1",
    "suggestion": {
    "keywords": [],
        "cities": []
},
    "districts": [
    {
        "citycode": [],
        "adcode": "100000",
        "name": "中华人民共和国",
        "center": "116.3683244,39.915085",
        "level": "country",
        "districts": [
            {
                "citycode": [],
                "adcode": "410000",
                "name": "河南省",
                "center": "113.753094,34.767052",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0379",
                        "adcode": "410300",
                        "name": "洛阳市",
                        "center": "112.453895,34.619702",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0395",
                        "adcode": "411100",
                        "name": "漯河市",
                        "center": "114.0166,33.58038",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0377",
                        "adcode": "411300",
                        "name": "南阳市",
                        "center": "112.584753,33.016102",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0376",
                        "adcode": "411500",
                        "name": "信阳市",
                        "center": "114.091058,32.148624",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0393",
                        "adcode": "410900",
                        "name": "濮阳市",
                        "center": "115.029246,35.762731",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0371",
                        "adcode": "410100",
                        "name": "郑州市",
                        "center": "113.625351,34.746303",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0398",
                        "adcode": "411200",
                        "name": "三门峡市",
                        "center": "111.200482,34.773196",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1391",
                        "adcode": "419001",
                        "name": "济源市",
                        "center": "112.602347,35.069057",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0374",
                        "adcode": "411000",
                        "name": "许昌市",
                        "center": "113.852004,34.03732",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0391",
                        "adcode": "410800",
                        "name": "焦作市",
                        "center": "113.241902,35.215726",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0373",
                        "adcode": "410700",
                        "name": "新乡市",
                        "center": "113.92679,35.303589",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0378",
                        "adcode": "410200",
                        "name": "开封市",
                        "center": "114.314278,34.798083",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0370",
                        "adcode": "411400",
                        "name": "商丘市",
                        "center": "115.656358,34.415165",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0394",
                        "adcode": "411600",
                        "name": "周口市",
                        "center": "114.701222,33.634652",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0396",
                        "adcode": "411700",
                        "name": "驻马店市",
                        "center": "114.021988,33.014038",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0375",
                        "adcode": "410400",
                        "name": "平顶山市",
                        "center": "113.192595,33.766554",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0372",
                        "adcode": "410500",
                        "name": "安阳市",
                        "center": "114.39248,36.098779",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0392",
                        "adcode": "410600",
                        "name": "鹤壁市",
                        "center": "114.297305,35.748329",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "440000",
                "name": "广东省",
                "center": "113.266887,23.133306",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0754",
                        "adcode": "440500",
                        "name": "汕头市",
                        "center": "116.681956,23.354152",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0757",
                        "adcode": "440600",
                        "name": "佛山市",
                        "center": "113.121586,23.021351",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0758",
                        "adcode": "441200",
                        "name": "肇庆市",
                        "center": "112.465245,23.047747",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0752",
                        "adcode": "441300",
                        "name": "惠州市",
                        "center": "114.415587,23.112368",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0755",
                        "adcode": "440300",
                        "name": "深圳市",
                        "center": "114.057939,22.543527",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0756",
                        "adcode": "440400",
                        "name": "珠海市",
                        "center": "113.576892,22.271644",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0750",
                        "adcode": "440700",
                        "name": "江门市",
                        "center": "113.081548,22.578948",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0662",
                        "adcode": "441700",
                        "name": "阳江市",
                        "center": "111.98343,21.856853",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0668",
                        "adcode": "440900",
                        "name": "茂名市",
                        "center": "110.925533,21.662728",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0759",
                        "adcode": "440800",
                        "name": "湛江市",
                        "center": "110.357538,21.270108",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0660",
                        "adcode": "441500",
                        "name": "汕尾市",
                        "center": "115.375557,22.787204",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0768",
                        "adcode": "445100",
                        "name": "潮州市",
                        "center": "116.621901,23.657662",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0663",
                        "adcode": "445200",
                        "name": "揭阳市",
                        "center": "116.372732,23.550968",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "020",
                        "adcode": "440100",
                        "name": "广州市",
                        "center": "113.264499,23.130061",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0753",
                        "adcode": "441400",
                        "name": "梅州市",
                        "center": "116.122046,24.288832",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0763",
                        "adcode": "441800",
                        "name": "清远市",
                        "center": "113.056098,23.682064",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0769",
                        "adcode": "441900",
                        "name": "东莞市",
                        "center": "113.751884,23.021016",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0751",
                        "adcode": "440200",
                        "name": "韶关市",
                        "center": "113.597324,24.810977",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0762",
                        "adcode": "441600",
                        "name": "河源市",
                        "center": "114.700215,23.744276",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0766",
                        "adcode": "445300",
                        "name": "云浮市",
                        "center": "112.044524,22.915163",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0760",
                        "adcode": "442000",
                        "name": "中山市",
                        "center": "113.392517,22.517024",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "150000",
                "name": "内蒙古自治区",
                "center": "111.765226,40.818233",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0478",
                        "adcode": "150800",
                        "name": "巴彦淖尔市",
                        "center": "107.387767,40.742987",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0473",
                        "adcode": "150300",
                        "name": "乌海市",
                        "center": "106.79415,39.655048",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0472",
                        "adcode": "150200",
                        "name": "包头市",
                        "center": "109.95315,40.621327",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0470",
                        "adcode": "150700",
                        "name": "呼伦贝尔市",
                        "center": "119.77845,49.166536",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0482",
                        "adcode": "152200",
                        "name": "兴安盟",
                        "center": "122.037796,46.082373",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0475",
                        "adcode": "150500",
                        "name": "通辽市",
                        "center": "122.243309,43.653566",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0476",
                        "adcode": "150400",
                        "name": "赤峰市",
                        "center": "118.887613,42.256876",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0479",
                        "adcode": "152500",
                        "name": "锡林郭勒盟",
                        "center": "116.047387,43.933212",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0474",
                        "adcode": "150900",
                        "name": "乌兰察布市",
                        "center": "113.132227,40.994526",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0483",
                        "adcode": "152900",
                        "name": "阿拉善盟",
                        "center": "105.729135,38.851554",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0477",
                        "adcode": "150600",
                        "name": "鄂尔多斯市",
                        "center": "109.782473,39.608744",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0471",
                        "adcode": "150100",
                        "name": "呼和浩特市",
                        "center": "111.748814,40.842127",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "230000",
                "name": "黑龙江省",
                "center": "126.661998,45.742253",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0457",
                        "adcode": "232700",
                        "name": "大兴安岭地区",
                        "center": "124.11786,50.41129",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0468",
                        "adcode": "230400",
                        "name": "鹤岗市",
                        "center": "130.297687,47.350659",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0456",
                        "adcode": "231100",
                        "name": "黑河市",
                        "center": "127.528226,50.244887",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0453",
                        "adcode": "231000",
                        "name": "牡丹江市",
                        "center": "129.632928,44.551486",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0458",
                        "adcode": "230700",
                        "name": "伊春市",
                        "center": "128.840863,47.728332",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0467",
                        "adcode": "230300",
                        "name": "鸡西市",
                        "center": "130.969385,45.295087",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0452",
                        "adcode": "230200",
                        "name": "齐齐哈尔市",
                        "center": "123.918193,47.354892",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0455",
                        "adcode": "231200",
                        "name": "绥化市",
                        "center": "126.968714,46.654147",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0459",
                        "adcode": "230600",
                        "name": "大庆市",
                        "center": "125.104078,46.589498",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0451",
                        "adcode": "230100",
                        "name": "哈尔滨市",
                        "center": "126.53505,45.802981",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0454",
                        "adcode": "230800",
                        "name": "佳木斯市",
                        "center": "130.318916,46.800002",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0464",
                        "adcode": "230900",
                        "name": "七台河市",
                        "center": "131.003015,45.771178",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0469",
                        "adcode": "230500",
                        "name": "双鸭山市",
                        "center": "131.141563,46.676157",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "650000",
                "name": "新疆维吾尔自治区",
                "center": "87.628579,43.793301",
                "level": "province",
                "districts": [
                    {
                        "citycode": "1906",
                        "adcode": "659005",
                        "name": "北屯市",
                        "center": "87.834419,47.326733",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1996",
                        "adcode": "659006",
                        "name": "铁门关市",
                        "center": "85.670291,41.862997",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1909",
                        "adcode": "659007",
                        "name": "双河市",
                        "center": "82.35365587,44.84052409",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0909",
                        "adcode": "652700",
                        "name": "博尔塔拉蒙古自治州",
                        "center": "82.066363,44.906039",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1999",
                        "adcode": "659008",
                        "name": "可克达拉市",
                        "center": "80.994153,43.940381",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0901",
                        "adcode": "654200",
                        "name": "塔城地区",
                        "center": "82.980316,46.745364",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1903",
                        "adcode": "659009",
                        "name": "昆玉市",
                        "center": "79.270193,37.215372",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0903",
                        "adcode": "653200",
                        "name": "和田地区",
                        "center": "79.921646,37.114406",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0906",
                        "adcode": "654300",
                        "name": "阿勒泰地区",
                        "center": "88.141253,47.844924",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0993",
                        "adcode": "659001",
                        "name": "石河子市",
                        "center": "86.080397,44.305368",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0994",
                        "adcode": "652300",
                        "name": "昌吉回族自治州",
                        "center": "87.308995,44.011044",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0996",
                        "adcode": "652800",
                        "name": "巴音郭楞蒙古自治州",
                        "center": "86.145298,41.764115",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0999",
                        "adcode": "654000",
                        "name": "伊犁哈萨克自治州",
                        "center": "81.323691,43.917106",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1997",
                        "adcode": "659002",
                        "name": "阿拉尔市",
                        "center": "81.280532,40.547205",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0998",
                        "adcode": "653100",
                        "name": "喀什地区",
                        "center": "75.990618,39.470215",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0990",
                        "adcode": "650200",
                        "name": "克拉玛依市",
                        "center": "84.889239,45.577712",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0995",
                        "adcode": "650400",
                        "name": "吐鲁番市",
                        "center": "89.250261,42.972736",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0902",
                        "adcode": "650500",
                        "name": "哈密市",
                        "center": "93.515053,42.819346",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "2940",
                        "adcode": "659011",
                        "name": "新星市",
                        "center": "93.74831,42.797043",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1998",
                        "adcode": "659003",
                        "name": "图木舒克市",
                        "center": "79.074965,39.867776",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0997",
                        "adcode": "652900",
                        "name": "阿克苏地区",
                        "center": "80.265068,41.170712",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0991",
                        "adcode": "650100",
                        "name": "乌鲁木齐市",
                        "center": "87.616824,43.825377",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0992",
                        "adcode": "659010",
                        "name": "胡杨河市",
                        "center": "84.827592,44.692894",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1994",
                        "adcode": "659004",
                        "name": "五家渠市",
                        "center": "87.542852,44.166489",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "2941",
                        "adcode": "659012",
                        "name": "白杨市",
                        "center": "82.896936,46.727959",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0908",
                        "adcode": "653000",
                        "name": "克孜勒苏柯尔克孜自治州",
                        "center": "76.168157,39.716236",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "420000",
                "name": "湖北省",
                "center": "114.341552,30.546222",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0710",
                        "adcode": "420600",
                        "name": "襄阳市",
                        "center": "112.121743,32.010161",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0719",
                        "adcode": "420300",
                        "name": "十堰市",
                        "center": "110.798921,32.629057",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0717",
                        "adcode": "420500",
                        "name": "宜昌市",
                        "center": "111.286962,30.69217",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "027",
                        "adcode": "420100",
                        "name": "武汉市",
                        "center": "114.304569,30.593354",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0713",
                        "adcode": "421100",
                        "name": "黄冈市",
                        "center": "114.872425,30.453722",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1728",
                        "adcode": "429006",
                        "name": "天门市",
                        "center": "113.166545,30.663706",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0712",
                        "adcode": "420900",
                        "name": "孝感市",
                        "center": "113.956962,30.918311",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0724",
                        "adcode": "420800",
                        "name": "荆门市",
                        "center": "112.199009,31.035445",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "2728",
                        "adcode": "429005",
                        "name": "潜江市",
                        "center": "112.900279,30.401954",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0718",
                        "adcode": "422800",
                        "name": "恩施土家族苗族自治州",
                        "center": "109.488076,30.272104",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0728",
                        "adcode": "429004",
                        "name": "仙桃市",
                        "center": "113.442973,30.328407",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0716",
                        "adcode": "421000",
                        "name": "荆州市",
                        "center": "112.24143,30.336282",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0715",
                        "adcode": "421200",
                        "name": "咸宁市",
                        "center": "114.322601,29.84135",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1719",
                        "adcode": "429021",
                        "name": "神农架林区",
                        "center": "110.675879,31.745103",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0722",
                        "adcode": "421300",
                        "name": "随州市",
                        "center": "113.382324,31.690275",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0711",
                        "adcode": "420700",
                        "name": "鄂州市",
                        "center": "114.894909,30.391461",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0714",
                        "adcode": "420200",
                        "name": "黄石市",
                        "center": "115.038999,30.201082",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "210000",
                "name": "辽宁省",
                "center": "123.435093,41.836743",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0429",
                        "adcode": "211400",
                        "name": "葫芦岛市",
                        "center": "120.836783,40.710974",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0411",
                        "adcode": "210200",
                        "name": "大连市",
                        "center": "121.614786,38.913962",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0415",
                        "adcode": "210600",
                        "name": "丹东市",
                        "center": "124.354419,40.000646",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0416",
                        "adcode": "210700",
                        "name": "锦州市",
                        "center": "121.126859,41.096114",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "024",
                        "adcode": "210100",
                        "name": "沈阳市",
                        "center": "123.464675,41.677576",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0410",
                        "adcode": "211200",
                        "name": "铁岭市",
                        "center": "123.726008,42.223709",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0418",
                        "adcode": "210900",
                        "name": "阜新市",
                        "center": "121.670052,42.022028",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0414",
                        "adcode": "210500",
                        "name": "本溪市",
                        "center": "123.766669,41.294123",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0419",
                        "adcode": "211000",
                        "name": "辽阳市",
                        "center": "123.239669,41.267396",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0413",
                        "adcode": "210400",
                        "name": "抚顺市",
                        "center": "123.957053,41.881311",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0427",
                        "adcode": "211100",
                        "name": "盘锦市",
                        "center": "122.170729,40.71956",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0421",
                        "adcode": "211300",
                        "name": "朝阳市",
                        "center": "120.488801,41.601855",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0412",
                        "adcode": "210300",
                        "name": "鞍山市",
                        "center": "122.994183,41.108239",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0417",
                        "adcode": "210800",
                        "name": "营口市",
                        "center": "122.219148,40.625027",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "370000",
                "name": "山东省",
                "center": "117.020725,36.670201",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0546",
                        "adcode": "370500",
                        "name": "东营市",
                        "center": "118.674633,37.433992",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0543",
                        "adcode": "371600",
                        "name": "滨州市",
                        "center": "117.970731,37.382687",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0535",
                        "adcode": "370600",
                        "name": "烟台市",
                        "center": "121.447755,37.464551",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0631",
                        "adcode": "371000",
                        "name": "威海市",
                        "center": "122.120519,37.513315",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0532",
                        "adcode": "370200",
                        "name": "青岛市",
                        "center": "120.382665,36.066938",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0635",
                        "adcode": "371500",
                        "name": "聊城市",
                        "center": "115.985238,36.455857",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0533",
                        "adcode": "370300",
                        "name": "淄博市",
                        "center": "118.054994,36.813787",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0531",
                        "adcode": "370100",
                        "name": "济南市",
                        "center": "117.120128,36.652069",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0536",
                        "adcode": "370700",
                        "name": "潍坊市",
                        "center": "119.161721,36.707668",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0538",
                        "adcode": "370900",
                        "name": "泰安市",
                        "center": "117.086963,36.201784",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0537",
                        "adcode": "370800",
                        "name": "济宁市",
                        "center": "116.587116,35.415117",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0539",
                        "adcode": "371300",
                        "name": "临沂市",
                        "center": "118.356464,35.103771",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0530",
                        "adcode": "371700",
                        "name": "菏泽市",
                        "center": "115.479646,35.234309",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0534",
                        "adcode": "371400",
                        "name": "德州市",
                        "center": "116.359244,37.436492",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0633",
                        "adcode": "371100",
                        "name": "日照市",
                        "center": "119.52685,35.416912",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0632",
                        "adcode": "370400",
                        "name": "枣庄市",
                        "center": "117.323759,34.810858",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": "021",
                "adcode": "310000",
                "name": "上海市",
                "center": "121.473667,31.230525",
                "level": "province",
                "districts": [
                    {
                        "citycode": "021",
                        "adcode": "310100",
                        "name": "上海城区",
                        "center": "121.472644,31.231706",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "520000",
                "name": "贵州省",
                "center": "106.705251,26.600328",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0852",
                        "adcode": "520300",
                        "name": "遵义市",
                        "center": "107.031922,27.721931",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0856",
                        "adcode": "520600",
                        "name": "铜仁市",
                        "center": "109.189528,27.731555",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0858",
                        "adcode": "520200",
                        "name": "六盘水市",
                        "center": "104.830357,26.592538",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0854",
                        "adcode": "522700",
                        "name": "黔南布依族苗族自治州",
                        "center": "107.522303,26.253136",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0853",
                        "adcode": "520400",
                        "name": "安顺市",
                        "center": "105.9476,26.253103",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0859",
                        "adcode": "522300",
                        "name": "黔西南布依族苗族自治州",
                        "center": "104.906419,25.087733",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0855",
                        "adcode": "522600",
                        "name": "黔东南苗族侗族自治州",
                        "center": "107.982838,26.583759",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0857",
                        "adcode": "520500",
                        "name": "毕节市",
                        "center": "105.291544,27.283615",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0851",
                        "adcode": "520100",
                        "name": "贵阳市",
                        "center": "106.628201,26.646694",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": "023",
                "adcode": "500000",
                "name": "重庆市",
                "center": "106.551787,29.56268",
                "level": "province",
                "districts": [
                    {
                        "citycode": "023",
                        "adcode": "500200",
                        "name": "重庆郊县",
                        "center": "108.170255,29.291965",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "023",
                        "adcode": "500100",
                        "name": "重庆城区",
                        "center": "106.504962,29.533155",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "340000",
                "name": "安徽省",
                "center": "117.330139,31.734559",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0562",
                        "adcode": "340700",
                        "name": "铜陵市",
                        "center": "117.811298,30.945214",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0566",
                        "adcode": "341700",
                        "name": "池州市",
                        "center": "117.495663,30.674264",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0556",
                        "adcode": "340800",
                        "name": "安庆市",
                        "center": "117.115349,30.531828",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0561",
                        "adcode": "340600",
                        "name": "淮北市",
                        "center": "116.798362,33.956264",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0555",
                        "adcode": "340500",
                        "name": "马鞍山市",
                        "center": "118.50685,31.668765",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0564",
                        "adcode": "341500",
                        "name": "六安市",
                        "center": "116.519729,31.735892",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1558",
                        "adcode": "341200",
                        "name": "阜阳市",
                        "center": "115.814252,32.891032",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0554",
                        "adcode": "340400",
                        "name": "淮南市",
                        "center": "117.018603,32.585384",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0557",
                        "adcode": "341300",
                        "name": "宿州市",
                        "center": "116.96419,33.647726",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0550",
                        "adcode": "341100",
                        "name": "滁州市",
                        "center": "118.333439,32.255904",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0551",
                        "adcode": "340100",
                        "name": "合肥市",
                        "center": "117.227267,31.820567",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0559",
                        "adcode": "341000",
                        "name": "黄山市",
                        "center": "118.337643,29.714886",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0552",
                        "adcode": "340300",
                        "name": "蚌埠市",
                        "center": "117.388566,32.91682",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0553",
                        "adcode": "340200",
                        "name": "芜湖市",
                        "center": "118.433065,31.352614",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0563",
                        "adcode": "341800",
                        "name": "宣城市",
                        "center": "118.759127,30.939278",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0558",
                        "adcode": "341600",
                        "name": "亳州市",
                        "center": "115.778588,33.846285",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "350000",
                "name": "福建省",
                "center": "119.296194,26.101082",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0593",
                        "adcode": "350900",
                        "name": "宁德市",
                        "center": "119.547729,26.666222",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0591",
                        "adcode": "350100",
                        "name": "福州市",
                        "center": "119.296411,26.074286",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0594",
                        "adcode": "350300",
                        "name": "莆田市",
                        "center": "119.007662,25.454202",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0595",
                        "adcode": "350500",
                        "name": "泉州市",
                        "center": "118.675724,24.874452",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0592",
                        "adcode": "350200",
                        "name": "厦门市",
                        "center": "118.08891,24.479627",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0596",
                        "adcode": "350600",
                        "name": "漳州市",
                        "center": "117.647298,24.515297",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0597",
                        "adcode": "350800",
                        "name": "龙岩市",
                        "center": "117.017362,25.075884",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0598",
                        "adcode": "350400",
                        "name": "三明市",
                        "center": "117.638919,26.263455",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0599",
                        "adcode": "350700",
                        "name": "南平市",
                        "center": "118.081325,27.382829",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "430000",
                "name": "湖南省",
                "center": "112.982951,28.116007",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0730",
                        "adcode": "430600",
                        "name": "岳阳市",
                        "center": "113.128922,29.35648",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0745",
                        "adcode": "431200",
                        "name": "怀化市",
                        "center": "110.001598,27.569813",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0743",
                        "adcode": "433100",
                        "name": "湘西土家族苗族自治州",
                        "center": "109.673345,28.215983",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0737",
                        "adcode": "430900",
                        "name": "益阳市",
                        "center": "112.355994,28.554853",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0744",
                        "adcode": "430800",
                        "name": "张家界市",
                        "center": "110.478887,29.117343",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0733",
                        "adcode": "430200",
                        "name": "株洲市",
                        "center": "113.132783,27.828862",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0738",
                        "adcode": "431300",
                        "name": "娄底市",
                        "center": "111.994468,27.699838",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0735",
                        "adcode": "431000",
                        "name": "郴州市",
                        "center": "113.015517,25.770117",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0746",
                        "adcode": "431100",
                        "name": "永州市",
                        "center": "111.613482,26.419861",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0734",
                        "adcode": "430400",
                        "name": "衡阳市",
                        "center": "112.572016,26.894216",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0736",
                        "adcode": "430700",
                        "name": "常德市",
                        "center": "111.69905,29.031446",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0739",
                        "adcode": "430500",
                        "name": "邵阳市",
                        "center": "111.467855,27.239528",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0732",
                        "adcode": "430300",
                        "name": "湘潭市",
                        "center": "112.945439,27.83136",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0731",
                        "adcode": "430100",
                        "name": "长沙市",
                        "center": "112.938882,28.228304",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "460000",
                "name": "海南省",
                "center": "110.348781,20.018639",
                "level": "province",
                "districts": [
                    {
                        "citycode": "1892",
                        "adcode": "469022",
                        "name": "屯昌县",
                        "center": "110.101667,19.351662",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0802",
                        "adcode": "469025",
                        "name": "白沙黎族自治县",
                        "center": "109.4429,19.221641",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1899",
                        "adcode": "469030",
                        "name": "琼中黎族苗族自治县",
                        "center": "109.838423,19.03327",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0807",
                        "adcode": "469007",
                        "name": "东方市",
                        "center": "108.651829,19.095187",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0809",
                        "adcode": "469028",
                        "name": "陵水黎族自治县",
                        "center": "110.037553,18.506045",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "2898",
                        "adcode": "460300",
                        "name": "三沙市",
                        "center": "112.338649,16.831004",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "2802",
                        "adcode": "469027",
                        "name": "乐东黎族自治县",
                        "center": "109.173384,18.750063",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1893",
                        "adcode": "469005",
                        "name": "文昌市",
                        "center": "110.797473,19.544234",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0899",
                        "adcode": "460200",
                        "name": "三亚市",
                        "center": "109.511709,18.252865",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1896",
                        "adcode": "469024",
                        "name": "临高县",
                        "center": "109.690508,19.912025",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0801",
                        "adcode": "469029",
                        "name": "保亭黎族苗族自治县",
                        "center": "109.700279,18.640339",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1897",
                        "adcode": "469001",
                        "name": "五指山市",
                        "center": "109.516784,18.774827",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0803",
                        "adcode": "469026",
                        "name": "昌江黎族自治县",
                        "center": "109.055783,19.298139",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0804",
                        "adcode": "469023",
                        "name": "澄迈县",
                        "center": "110.007497,19.738885",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0806",
                        "adcode": "469021",
                        "name": "定安县",
                        "center": "110.358001,19.681215",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0898",
                        "adcode": "460100",
                        "name": "海口市",
                        "center": "110.200162,20.046316",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0805",
                        "adcode": "460400",
                        "name": "儋州市",
                        "center": "109.580812,19.520948",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1894",
                        "adcode": "469002",
                        "name": "琼海市",
                        "center": "110.474524,19.259112",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1898",
                        "adcode": "469006",
                        "name": "万宁市",
                        "center": "110.392605,18.793697",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "320000",
                "name": "江苏省",
                "center": "118.763563,32.061377",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0518",
                        "adcode": "320700",
                        "name": "连云港市",
                        "center": "119.221487,34.596639",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0513",
                        "adcode": "320600",
                        "name": "南通市",
                        "center": "120.894522,31.981269",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "025",
                        "adcode": "320100",
                        "name": "南京市",
                        "center": "118.796624,32.059344",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0512",
                        "adcode": "320500",
                        "name": "苏州市",
                        "center": "120.585294,31.299758",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0527",
                        "adcode": "321300",
                        "name": "宿迁市",
                        "center": "118.275228,33.963186",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0514",
                        "adcode": "321000",
                        "name": "扬州市",
                        "center": "119.412834,32.394404",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0511",
                        "adcode": "321100",
                        "name": "镇江市",
                        "center": "119.424441,32.188141",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0517",
                        "adcode": "320800",
                        "name": "淮安市",
                        "center": "119.113166,33.551495",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0516",
                        "adcode": "320300",
                        "name": "徐州市",
                        "center": "117.283752,34.204224",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0519",
                        "adcode": "320400",
                        "name": "常州市",
                        "center": "119.974092,31.811313",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0515",
                        "adcode": "320900",
                        "name": "盐城市",
                        "center": "120.16263,33.348176",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0523",
                        "adcode": "321200",
                        "name": "泰州市",
                        "center": "119.922883,32.456692",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0510",
                        "adcode": "320200",
                        "name": "无锡市",
                        "center": "120.311889,31.491064",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "630000",
                "name": "青海省",
                "center": "101.780482,36.622538",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0972",
                        "adcode": "630200",
                        "name": "海东市",
                        "center": "102.41064,36.473448",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0974",
                        "adcode": "632500",
                        "name": "海南藏族自治州",
                        "center": "100.622647,36.296399",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0977",
                        "adcode": "632800",
                        "name": "海西蒙古族藏族自治州",
                        "center": "97.33197,37.348114",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0976",
                        "adcode": "632700",
                        "name": "玉树藏族自治州",
                        "center": "97.006292,33.006308",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0973",
                        "adcode": "632300",
                        "name": "黄南藏族自治州",
                        "center": "102.015397,35.519317",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0975",
                        "adcode": "632600",
                        "name": "果洛藏族自治州",
                        "center": "100.245161,34.472179",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0970",
                        "adcode": "632200",
                        "name": "海北藏族自治州",
                        "center": "100.900944,36.954612",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0971",
                        "adcode": "630100",
                        "name": "西宁市",
                        "center": "101.758249,36.676027",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "450000",
                "name": "广西壮族自治区",
                "center": "108.327537,22.816659",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0776",
                        "adcode": "451000",
                        "name": "百色市",
                        "center": "106.61869,23.90307",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0779",
                        "adcode": "450500",
                        "name": "北海市",
                        "center": "109.120248,21.481305",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0777",
                        "adcode": "450700",
                        "name": "钦州市",
                        "center": "108.654355,21.980894",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0770",
                        "adcode": "450600",
                        "name": "防城港市",
                        "center": "108.35467,21.686732",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0778",
                        "adcode": "451200",
                        "name": "河池市",
                        "center": "108.63639,24.48523",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0772",
                        "adcode": "450200",
                        "name": "柳州市",
                        "center": "109.428071,24.326442",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1772",
                        "adcode": "451300",
                        "name": "来宾市",
                        "center": "109.221243,23.750105",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0771",
                        "adcode": "450100",
                        "name": "南宁市",
                        "center": "108.366407,22.8177",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0774",
                        "adcode": "450400",
                        "name": "梧州市",
                        "center": "111.279022,23.476733",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1755",
                        "adcode": "450800",
                        "name": "贵港市",
                        "center": "109.598903,23.11182",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0775",
                        "adcode": "450900",
                        "name": "玉林市",
                        "center": "110.18097,22.654001",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1771",
                        "adcode": "451400",
                        "name": "崇左市",
                        "center": "107.364973,22.377139",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1774",
                        "adcode": "451100",
                        "name": "贺州市",
                        "center": "111.567216,24.404182",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0773",
                        "adcode": "450300",
                        "name": "桂林市",
                        "center": "110.179752,25.235615",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "640000",
                "name": "宁夏回族自治区",
                "center": "106.258889,38.472273",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0954",
                        "adcode": "640400",
                        "name": "固原市",
                        "center": "106.24267,36.01628",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0952",
                        "adcode": "640200",
                        "name": "石嘴山市",
                        "center": "106.382792,38.984632",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1953",
                        "adcode": "640500",
                        "name": "中卫市",
                        "center": "105.19677,37.500185",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0953",
                        "adcode": "640300",
                        "name": "吴忠市",
                        "center": "106.198613,37.997755",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0951",
                        "adcode": "640100",
                        "name": "银川市",
                        "center": "106.230977,38.487783",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "330000",
                "name": "浙江省",
                "center": "120.152575,30.266619",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0580",
                        "adcode": "330900",
                        "name": "舟山市",
                        "center": "122.207395,29.985578",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0573",
                        "adcode": "330400",
                        "name": "嘉兴市",
                        "center": "120.755623,30.746814",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0574",
                        "adcode": "330200",
                        "name": "宁波市",
                        "center": "121.62454,29.860258",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0576",
                        "adcode": "331000",
                        "name": "台州市",
                        "center": "121.42079,28.655716",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0577",
                        "adcode": "330300",
                        "name": "温州市",
                        "center": "120.699279,27.993849",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0578",
                        "adcode": "331100",
                        "name": "丽水市",
                        "center": "119.923249,28.467694",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0570",
                        "adcode": "330800",
                        "name": "衢州市",
                        "center": "118.859307,28.970229",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0579",
                        "adcode": "330700",
                        "name": "金华市",
                        "center": "119.647265,29.079195",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0571",
                        "adcode": "330100",
                        "name": "杭州市",
                        "center": "120.209903,30.246566",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0575",
                        "adcode": "330600",
                        "name": "绍兴市",
                        "center": "120.582886,30.051549",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0572",
                        "adcode": "330500",
                        "name": "湖州市",
                        "center": "120.086881,30.894178",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "130000",
                "name": "河北省",
                "center": "114.530399,38.037707",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0315",
                        "adcode": "130200",
                        "name": "唐山市",
                        "center": "118.180149,39.63068",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0335",
                        "adcode": "130300",
                        "name": "秦皇岛市",
                        "center": "119.52022,39.888243",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0317",
                        "adcode": "130900",
                        "name": "沧州市",
                        "center": "116.838715,38.304676",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0310",
                        "adcode": "130400",
                        "name": "邯郸市",
                        "center": "114.53915,36.625849",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0311",
                        "adcode": "130100",
                        "name": "石家庄市",
                        "center": "114.514976,38.042007",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0316",
                        "adcode": "131000",
                        "name": "廊坊市",
                        "center": "116.683546,39.538304",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0312",
                        "adcode": "130600",
                        "name": "保定市",
                        "center": "115.464523,38.874476",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0313",
                        "adcode": "130700",
                        "name": "张家口市",
                        "center": "114.885895,40.768931",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0318",
                        "adcode": "131100",
                        "name": "衡水市",
                        "center": "115.668987,37.739367",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0319",
                        "adcode": "130500",
                        "name": "邢台市",
                        "center": "114.49742,37.060227",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0314",
                        "adcode": "130800",
                        "name": "承德市",
                        "center": "117.962749,40.952942",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": "1852",
                "adcode": "810000",
                "name": "香港特别行政区",
                "center": "114.170714,22.278354",
                "level": "province",
                "districts": [
                    {
                        "citycode": "1852",
                        "adcode": "810006",
                        "name": "深水埗区",
                        "center": "114.1632417,22.33385417",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810013",
                        "name": "北区",
                        "center": "114.1473639,22.49610389",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810008",
                        "name": "黄大仙区",
                        "center": "114.2038856,22.33632056",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810015",
                        "name": "西贡区",
                        "center": "114.264645,22.31421306",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810016",
                        "name": "沙田区",
                        "center": "114.1953653,22.37953167",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810011",
                        "name": "屯门区",
                        "center": "113.9765742,22.39384417",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810014",
                        "name": "大埔区",
                        "center": "114.1717431,22.44565306",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810007",
                        "name": "九龙城区",
                        "center": "114.1928467,22.31251",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810009",
                        "name": "观塘区",
                        "center": "114.2140542,22.32083778",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810005",
                        "name": "油尖旺区",
                        "center": "114.1733317,22.31170389",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810004",
                        "name": "南区",
                        "center": "114.1600117,22.24589667",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810018",
                        "name": "离岛区",
                        "center": "113.94612,22.28640778",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810003",
                        "name": "东区",
                        "center": "114.2260031,22.27969306",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810001",
                        "name": "中西区",
                        "center": "114.1543731,22.28198083",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810002",
                        "name": "湾仔区",
                        "center": "114.1829153,22.27638889",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810012",
                        "name": "元朗区",
                        "center": "114.0324381,22.44142833",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810010",
                        "name": "荃湾区",
                        "center": "114.1210792,22.36830667",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1852",
                        "adcode": "810017",
                        "name": "葵青区",
                        "center": "114.1393194,22.36387667",
                        "level": "district",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": "1886",
                "adcode": "710000",
                "name": "台湾省",
                "center": "121.509062,25.044332",
                "level": "province",
                "districts": []
            },
            {
                "citycode": "1853",
                "adcode": "820000",
                "name": "澳门特别行政区",
                "center": "113.543076,22.186927",
                "level": "province",
                "districts": [
                    {
                        "citycode": "1853",
                        "adcode": "820002",
                        "name": "花王堂区",
                        "center": "113.5489608,22.1992075",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1853",
                        "adcode": "820006",
                        "name": "嘉模堂区",
                        "center": "113.5587044,22.15375944",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1853",
                        "adcode": "820003",
                        "name": "望德堂区",
                        "center": "113.5501828,22.19372083",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1853",
                        "adcode": "820008",
                        "name": "圣方济各堂区",
                        "center": "113.5599542,22.12348639",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1853",
                        "adcode": "820007",
                        "name": "路氹填海区",
                        "center": "113.5695992,22.13663",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1853",
                        "adcode": "820005",
                        "name": "风顺堂区",
                        "center": "113.5419278,22.18736806",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1853",
                        "adcode": "820004",
                        "name": "大堂区",
                        "center": "113.5536475,22.18853944",
                        "level": "district",
                        "districts": []
                    },
                    {
                        "citycode": "1853",
                        "adcode": "820001",
                        "name": "花地玛堂区",
                        "center": "113.5528956,22.20787",
                        "level": "district",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "620000",
                "name": "甘肃省",
                "center": "103.826777,36.060634",
                "level": "province",
                "districts": [
                    {
                        "citycode": "1937",
                        "adcode": "620200",
                        "name": "嘉峪关市",
                        "center": "98.2882,39.77325",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0937",
                        "adcode": "620900",
                        "name": "酒泉市",
                        "center": "98.49432,39.733416",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0931",
                        "adcode": "620100",
                        "name": "兰州市",
                        "center": "103.834228,36.060798",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0933",
                        "adcode": "620800",
                        "name": "平凉市",
                        "center": "106.664913,35.542417",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0935",
                        "adcode": "620300",
                        "name": "金昌市",
                        "center": "102.187972,38.521468",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0938",
                        "adcode": "620500",
                        "name": "天水市",
                        "center": "105.724828,34.581514",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0943",
                        "adcode": "620400",
                        "name": "白银市",
                        "center": "104.138872,36.545123",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1935",
                        "adcode": "620600",
                        "name": "武威市",
                        "center": "102.637821,37.92898",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0936",
                        "adcode": "620700",
                        "name": "张掖市",
                        "center": "100.449858,38.924766",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0932",
                        "adcode": "621100",
                        "name": "定西市",
                        "center": "104.592342,35.607947",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0941",
                        "adcode": "623000",
                        "name": "甘南藏族自治州",
                        "center": "102.911736,34.983266",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "2935",
                        "adcode": "621200",
                        "name": "陇南市",
                        "center": "104.960296,33.370174",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0934",
                        "adcode": "621000",
                        "name": "庆阳市",
                        "center": "107.643433,35.709459",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0930",
                        "adcode": "622900",
                        "name": "临夏回族自治州",
                        "center": "103.210386,35.601792",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "510000",
                "name": "四川省",
                "center": "104.076452,30.651696",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0839",
                        "adcode": "510800",
                        "name": "广元市",
                        "center": "105.844004,32.435774",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0817",
                        "adcode": "511300",
                        "name": "南充市",
                        "center": "106.110565,30.837235",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0827",
                        "adcode": "511900",
                        "name": "巴中市",
                        "center": "106.747548,31.867853",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0838",
                        "adcode": "510600",
                        "name": "德阳市",
                        "center": "104.397795,31.127449",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0816",
                        "adcode": "510700",
                        "name": "绵阳市",
                        "center": "104.679127,31.467673",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "028",
                        "adcode": "510100",
                        "name": "成都市",
                        "center": "104.066301,30.572961",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0826",
                        "adcode": "511600",
                        "name": "广安市",
                        "center": "106.632647,30.456354",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0818",
                        "adcode": "511700",
                        "name": "达州市",
                        "center": "107.46778,31.209278",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0825",
                        "adcode": "510900",
                        "name": "遂宁市",
                        "center": "105.592602,30.53268",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0832",
                        "adcode": "512000",
                        "name": "资阳市",
                        "center": "104.627265,30.129236",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1833",
                        "adcode": "511400",
                        "name": "眉山市",
                        "center": "103.848417,30.077113",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1832",
                        "adcode": "511000",
                        "name": "内江市",
                        "center": "105.057992,29.58021",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0833",
                        "adcode": "511100",
                        "name": "乐山市",
                        "center": "103.766085,29.552275",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0813",
                        "adcode": "510300",
                        "name": "自贡市",
                        "center": "104.779307,29.33924",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0830",
                        "adcode": "510500",
                        "name": "泸州市",
                        "center": "105.441866,28.87098",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0831",
                        "adcode": "511500",
                        "name": "宜宾市",
                        "center": "104.642826,28.752354",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0834",
                        "adcode": "513400",
                        "name": "凉山彝族自治州",
                        "center": "102.267713,27.881396",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0812",
                        "adcode": "510400",
                        "name": "攀枝花市",
                        "center": "101.729116,26.558645",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0836",
                        "adcode": "513300",
                        "name": "甘孜藏族自治州",
                        "center": "101.96231,30.04952",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0835",
                        "adcode": "511800",
                        "name": "雅安市",
                        "center": "103.041538,30.009998",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0837",
                        "adcode": "513200",
                        "name": "阿坝藏族羌族自治州",
                        "center": "102.224504,31.899427",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": "022",
                "adcode": "120000",
                "name": "天津市",
                "center": "117.201509,39.085318",
                "level": "province",
                "districts": [
                    {
                        "citycode": "022",
                        "adcode": "120100",
                        "name": "天津城区",
                        "center": "117.190182,39.125596",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "140000",
                "name": "山西省",
                "center": "112.578781,37.813948",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0353",
                        "adcode": "140300",
                        "name": "阳泉市",
                        "center": "113.580426,37.857094",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0352",
                        "adcode": "140200",
                        "name": "大同市",
                        "center": "113.366749,40.09711",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0358",
                        "adcode": "141100",
                        "name": "吕梁市",
                        "center": "111.14454,37.518996",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0359",
                        "adcode": "140800",
                        "name": "运城市",
                        "center": "111.007051,35.02667",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0356",
                        "adcode": "140500",
                        "name": "晋城市",
                        "center": "112.852022,35.491315",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0355",
                        "adcode": "140400",
                        "name": "长治市",
                        "center": "113.117394,36.195142",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0349",
                        "adcode": "140600",
                        "name": "朔州市",
                        "center": "112.432906,39.331734",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0350",
                        "adcode": "140900",
                        "name": "忻州市",
                        "center": "112.734149,38.415958",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0351",
                        "adcode": "140100",
                        "name": "太原市",
                        "center": "112.549656,37.870451",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0357",
                        "adcode": "141000",
                        "name": "临汾市",
                        "center": "111.51931,36.088581",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0354",
                        "adcode": "140700",
                        "name": "晋中市",
                        "center": "112.752633,37.688006",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "610000",
                "name": "陕西省",
                "center": "108.953939,34.266611",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0914",
                        "adcode": "611000",
                        "name": "商洛市",
                        "center": "109.918646,33.873358",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0916",
                        "adcode": "610700",
                        "name": "汉中市",
                        "center": "107.02319,33.066373",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "029",
                        "adcode": "610100",
                        "name": "西安市",
                        "center": "108.939645,34.343207",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0912",
                        "adcode": "610800",
                        "name": "榆林市",
                        "center": "109.734104,38.28576",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0910",
                        "adcode": "610400",
                        "name": "咸阳市",
                        "center": "108.708837,34.329896",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0917",
                        "adcode": "610300",
                        "name": "宝鸡市",
                        "center": "107.237682,34.362862",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0915",
                        "adcode": "610900",
                        "name": "安康市",
                        "center": "109.029017,32.685435",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0911",
                        "adcode": "610600",
                        "name": "延安市",
                        "center": "109.49468,36.650109",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0919",
                        "adcode": "610200",
                        "name": "铜川市",
                        "center": "108.945116,34.897133",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0913",
                        "adcode": "610500",
                        "name": "渭南市",
                        "center": "109.470962,34.520632",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": "010",
                "adcode": "110000",
                "name": "北京市",
                "center": "116.407387,39.904179",
                "level": "province",
                "districts": [
                    {
                        "citycode": "010",
                        "adcode": "110100",
                        "name": "北京城区",
                        "center": "116.405285,39.904989",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "360000",
                "name": "江西省",
                "center": "115.816587,28.637234",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0790",
                        "adcode": "360500",
                        "name": "新余市",
                        "center": "114.916665,27.818553",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0796",
                        "adcode": "360800",
                        "name": "吉安市",
                        "center": "114.96681,27.091243",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0794",
                        "adcode": "361000",
                        "name": "抚州市",
                        "center": "116.358054,27.948979",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0701",
                        "adcode": "360600",
                        "name": "鹰潭市",
                        "center": "117.039532,28.272092",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0795",
                        "adcode": "360900",
                        "name": "宜春市",
                        "center": "114.416826,27.816245",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0799",
                        "adcode": "360300",
                        "name": "萍乡市",
                        "center": "113.887147,27.658721",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0798",
                        "adcode": "360200",
                        "name": "景德镇市",
                        "center": "117.184892,29.2744",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0792",
                        "adcode": "360400",
                        "name": "九江市",
                        "center": "115.95356,29.66116",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0791",
                        "adcode": "360100",
                        "name": "南昌市",
                        "center": "115.857972,28.682976",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0793",
                        "adcode": "361100",
                        "name": "上饶市",
                        "center": "117.943064,28.45513",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0797",
                        "adcode": "360700",
                        "name": "赣州市",
                        "center": "114.933494,25.831139",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "220000",
                "name": "吉林省",
                "center": "125.325802,43.896942",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0432",
                        "adcode": "220200",
                        "name": "吉林市",
                        "center": "126.549719,43.838132",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0431",
                        "adcode": "220100",
                        "name": "长春市",
                        "center": "125.323643,43.816996",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0436",
                        "adcode": "220800",
                        "name": "白城市",
                        "center": "122.838102,45.620131",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0438",
                        "adcode": "220700",
                        "name": "松原市",
                        "center": "124.825321,45.14191",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0434",
                        "adcode": "220300",
                        "name": "四平市",
                        "center": "124.350599,43.166764",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0437",
                        "adcode": "220400",
                        "name": "辽源市",
                        "center": "125.144676,42.887961",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0435",
                        "adcode": "220500",
                        "name": "通化市",
                        "center": "125.939721,41.728312",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "1433",
                        "adcode": "222400",
                        "name": "延边朝鲜族自治州",
                        "center": "129.470605,42.909426",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0439",
                        "adcode": "220600",
                        "name": "白山市",
                        "center": "126.414274,41.944132",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "540000",
                "name": "西藏自治区",
                "center": "91.117449,29.648694",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0895",
                        "adcode": "540300",
                        "name": "昌都市",
                        "center": "97.170425,31.142879",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0896",
                        "adcode": "540600",
                        "name": "那曲市",
                        "center": "92.05151,31.477905",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0891",
                        "adcode": "540100",
                        "name": "拉萨市",
                        "center": "91.171924,29.653491",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0892",
                        "adcode": "540200",
                        "name": "日喀则市",
                        "center": "88.880423,29.266838",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0893",
                        "adcode": "540500",
                        "name": "山南市",
                        "center": "91.771426,29.237722",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0894",
                        "adcode": "540400",
                        "name": "林芝市",
                        "center": "94.361436,29.64875",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0897",
                        "adcode": "542500",
                        "name": "阿里地区",
                        "center": "80.105786,32.500987",
                        "level": "city",
                        "districts": []
                    }
                ]
            },
            {
                "citycode": [],
                "adcode": "530000",
                "name": "云南省",
                "center": "102.709372,25.046432",
                "level": "province",
                "districts": [
                    {
                        "citycode": "0870",
                        "adcode": "530600",
                        "name": "昭通市",
                        "center": "103.717078,27.338185",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0874",
                        "adcode": "530300",
                        "name": "曲靖市",
                        "center": "103.796288,25.490866",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0873",
                        "adcode": "532500",
                        "name": "红河哈尼族彝族自治州",
                        "center": "103.374873,23.363129",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0886",
                        "adcode": "533300",
                        "name": "怒江傈僳族自治州",
                        "center": "98.8566,25.817555",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0877",
                        "adcode": "530400",
                        "name": "玉溪市",
                        "center": "102.526673,24.346786",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0872",
                        "adcode": "532900",
                        "name": "大理白族自治州",
                        "center": "100.267608,25.606548",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0887",
                        "adcode": "533400",
                        "name": "迪庆藏族自治州",
                        "center": "99.70211,27.819149",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0883",
                        "adcode": "530900",
                        "name": "临沧市",
                        "center": "100.088837,23.884175",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0875",
                        "adcode": "530500",
                        "name": "保山市",
                        "center": "99.161489,25.112018",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0888",
                        "adcode": "530700",
                        "name": "丽江市",
                        "center": "100.225936,26.855165",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0691",
                        "adcode": "532800",
                        "name": "西双版纳傣族自治州",
                        "center": "100.797002,22.009037",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0878",
                        "adcode": "532300",
                        "name": "楚雄彝族自治州",
                        "center": "101.528304,25.045678",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0871",
                        "adcode": "530100",
                        "name": "昆明市",
                        "center": "102.833669,24.88149",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0879",
                        "adcode": "530800",
                        "name": "普洱市",
                        "center": "100.966011,22.825229",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0876",
                        "adcode": "532600",
                        "name": "文山壮族苗族自治州",
                        "center": "104.21567,23.400983",
                        "level": "city",
                        "districts": []
                    },
                    {
                        "citycode": "0692",
                        "adcode": "533100",
                        "name": "德宏傣族景颇族自治州",
                        "center": "98.585621,24.433146",
                        "level": "city",
                        "districts": []
                    }
                ]
            }
        ]
    }
]
}
